exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.confirm-checkbox .v-input--checkbox[data-v-64e2a363] {\n  margin-top: 0;\n}\n", ""]);

// exports
